var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card as MuiCard, useTheme, } from '@mui/material';
export var variants = ['default', 'primary', 'secondary'];
export default function PFCard(_a) {
    var sx = _a.sx, _b = _a.pfVariant, pfVariant = _b === void 0 ? 'default' : _b, backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, props = __rest(_a, ["sx", "pfVariant", "backgroundColor", "borderColor"]);
    var theme = useTheme();
    var bgColor = backgroundColor || theme.palette.background.paper;
    var borderColorValue = borderColor || 'primary.90';
    var sxVariants = {
        default: {
            boxShadow: 'unset',
            borderTopColor: 'transparent',
            borderTopWidth: '0px',
            backgroundColor: bgColor,
        },
        primary: {
            color: theme.palette.primary.contrastText,
            boxShadow: 'unset',
            backgroundColor: bgColor,
            borderTopColor: borderColorValue,
        },
        secondary: {
            backgroundColor: bgColor,
            boxShadow: 'unset',
            borderTopColor: borderColorValue,
        },
    };
    return (_jsx(MuiCard, __assign({ sx: pfVariant
            ? __assign(__assign({}, sxVariants[pfVariant]), sx)
            : sx }, props)));
}
